(function () {
	'use strict';
	angular.module('app.setup')
		.controller('cloneValueStreamsMetrics', cloneValueStreamsMetrics);

	cloneValueStreamsMetrics.$inject = ['$rootScope', '$scope', '$uibModal', 'siteService', 'metricsService', 'storeService', 'configureMetricService'];

	function cloneValueStreamsMetrics($rootScope, $scope, $uibModal, siteService, metricsService, storeService, configureMetricService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var allowedMetricTypes = ['Manual', 'Automatic'];
		vm.metrics = [];
		vm.sites = [];
		vm.valueStreams = [];
		vm.selectedValueStreams;
		vm.selectedMetrics;
		vm.lastSelectedSite;
		vm.selectedSite = undefined;
		vm.loadingDependency = 0;
		vm.addSite = addSite;
		vm.save = save;
		vm.allowedToSave = allowedToSave;

		init();

		function init() {
			resetPage();
			metricsService.getMetrics('ValueStream', adminConfig.factory.id)
				.then(function (response) {
					if (response && response.length) {
						vm.metrics = response.filter(function (metric) {
							return allowedMetricTypes.includes(metric.metricType);
						});
					}
				});
			siteService.getSiblingSites(adminConfig.factory.id)
				.then(function (response) {
					vm.sites = response;
				});
		}

		function addSite($site) {
			if ($site.ndx !== vm.lastSelectedSite) {
				vm.valueStreams = [];
				vm.selectedValueStreams = undefined;
				vm.users = {};
				vm.lastSelectedSite = $site.ndx;
				vm.loadingDependency = 0;
			} else {
				return;
			}
			siteService.getUsersForSite($site.ndx, true)
				.then(function (response) {
					_.set(vm.users, $site.ndx, {
						'name': $site.name,
						'users': response
					});
					vm.loadingDependency += 1;
				});
			configureMetricService.getValueStreams(false, $site.ndx)
				.then(function (valueStreams) {
					vm.valueStreams = valueStreams;
					vm.loadingDependency += 1;
				});
		}

		function save() {
			var valid = allowedToSave();

			// Clones
			if (valid) {
				var userNdx;
				_.forEach(vm.users, function (value, key) {
					userNdx = value.selected.ndx;
				});
				var requestBody = {
					factoryNdx: vm.selectedSite,
					userNdx: userNdx,
					valueStreams: [],
					metrics: []
				};

				for (var i = 0; i < vm.selectedMetrics.length; i++) {
					requestBody.metrics.push(vm.selectedMetrics[i].ndx);
				}
				for (var i = 0; i < vm.selectedValueStreams.length; i++) {
					requestBody.valueStreams.push(vm.selectedValueStreams[i].ndx);
				}

				metricsService.cloneValueSteamMetrics(adminConfig.factory.id, requestBody)
					.then(function (response) {
						processCloneResponse(response);
						resetPage();
					}, function (error) {
						$rootScope.$emit('toast', {
							'message': 'Error Cloning Metrics',
							'success': false
						});
						resetPage();
					});
			}
		}

		function allowedToSave() { 
			var valid = true;
			// Clear Errors
			jQuery('.metrics-select').removeClass('error-border');
			jQuery('.sites-select').removeClass('error-border');
			jQuery('.valuestreams-select').removeClass('error-border');
			jQuery('.user-select').removeClass('error-border');

			// Validations
			if (vm.selectedMetrics.length === 0) {
				$rootScope.$emit('toast', {
					'message': 'Please select at least one metric.',
					'success': false
				});
				jQuery('.metrics-select').addClass('error-border');
				valid = false;
			}
			if (!vm.selectedSite) {
				$rootScope.$emit('toast', {
					'message': 'Please select at least one site.',
					'success': false
				});
				jQuery('.sites-select').addClass('error-border');
				valid = false;
			}

			if (!vm.selectedValueStreams || vm.selectedValueStreams.length === 0) {
				$rootScope.$emit('toast', {
					'message': 'Please select a value stream for metric',
					'success': false
				});
				jQuery('.valuestreams-select').addClass('error-border');
				valid = false;
			}

			_.forEach(vm.users, function (value, key) {
				if (!value.selected) {
					$rootScope.$emit('toast', {
						'message': 'Please select a user for site',
						'success': false
					});
					jQuery('.user-select').addClass('error-border');
					valid = false;
				}
			});
			return valid;
		}

		function resetPage() {
			vm.selectedMetrics = [];
			vm.valueStreams = [];
			vm.selectedSite = undefined;
			vm.selectedValueStreams = undefined;
			vm.lastSelectedSite = undefined;
			vm.users = {};
			vm.loadingDependency = 0;
		}

		function processCloneResponse(response) { 
			var success = 0;
			var failure = 0;
			var details = [];
			angular.forEach(response, function (value, key) {
				var message = JSON.parse(value);
				success = message.success ? success + 1 : success + 0;
				failure = message.error ? failure + 1 : failure + 0;
				details.push({
					key: key,
					value: message.success || message.error
				});
			});
			showMetricsCloneDetails(success, failure, details);
		}

		function showMetricsCloneDetails(success, failure, details) {
			var detailsScope = $scope.$new();
			detailsScope.success = success;
			detailsScope.failure = failure;
			detailsScope.details = details;
			var opts = {
				scope: detailsScope,
				templateUrl: '/application/f/setup/metricsAndGoals/cloneMetrics/valuestream-metrics-clone-details.html',
				backdrop: 'static',
				windowTemplateUrl: '/application/f/reports/upload_comments_template.html'
			};
			var instance = $uibModal.open(opts);
			detailsScope.closeModal = function () {
				instance.close();
				detailsScope.$destroy();
			};
		}
	}

})();
